import type { ReactNode } from 'react';

import { TruncatedTextWithTooltip } from '@/shared/ui/text/truncated-text-with-tooltip';

interface ClientTableNameCellProps {
    name: string;
    children: ReactNode;
}

export function ClientTableNameCell({ name, children }: ClientTableNameCellProps) {
    return (
        <div className="flex items-center gap-2 h-[36px] py-2 min-w-0">
            <div className="xs:hidden">{children}</div>
            <div className="min-w-0 flex-1">
                <TruncatedTextWithTooltip text={name} />
            </div>
        </div>
    );
}
